import type { ComponentProps, MouseEvent, ReactNode } from "react";
import { LANDING_URL } from "../constants/links";
import { trackRegisterClick } from "../lib/analytics";

type RegisterLinkProps = Omit<ComponentProps<"a">, "href"> & {
  source: string;
  href?: string;
  children: ReactNode;
};

export default function RegisterLink({
  source,
  href = LANDING_URL,
  onClick,
  children,
  ...props
}: RegisterLinkProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    trackRegisterClick({
      source,
      linkText: typeof children === "string" ? children : undefined,
      href,
    });
    onClick?.(event);
  };

  return (
    <a href={href} onClick={handleClick} {...props}>
      {children}
    </a>
  );
}
